module.exports = __webpack_public_path__ + "static/media/ic-brand-color.56c6406d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Simulating/ic-brand-color.svg
// module id = 1072
// module chunks = 0